"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.numericUnicodeMap={0:65533,128:8364,130:8218,131:402,132:8222,133:8230,134:8224,135:8225,136:710,137:8240,138:352,139:8249,140:338,142:381,145:8216,146:8217,147:8220,148:8221,149:8226,150:8211,151:8212,152:732,153:8482,154:353,155:8250,156:339,158:382,159:376};


//////////////////
// WEBPACK FOOTER
// ./~/html-entities/lib/numeric-unicode-map.js
// module id = ./node_modules/html-entities/lib/numeric-unicode-map.js
// module chunks = 1